import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IMaskInput } from 'react-imask';
import { useField } from 'formik';
import useInput from '../hooks/useInput';
import FormikInputWrapper from './FormikInputWrapper';

export function FormikMaskedInput(
  {
    id: defaultId,
    label,
    name,
    placeholder,
    inputRef,
    type = 'text',
    classInput,
    icon,
    swap = false,
    iconProps = {},
    className,
    mask,
    disabled
  }
) {
  const [field, meta, helpers] = useField(name);
  const {
    id,
    idIcon,
    idFeedback,
    ariaDescribedby
  } = useInput(defaultId, label, icon);
  return (
    <div className={classNames(className)}>
      <FormikInputWrapper
        label={label}
        id={id}
        icon={icon}
        idIcon={idIcon}
        swap={swap}
        iconProps={iconProps}
        idFeedback={idFeedback}
        meta={meta}
      >
        <IMaskInput
          id={id}
          mask={mask}
          name={name}
          placeholder={placeholder}
          inputRef={inputRef}
          type={type}
          disabled={disabled}
          value={field.value}
          {...field}
          onAccept={(value) => helpers.setValue(value)}
          onComplete={(value) => helpers.setValue(value)}
          className={classNames(
            'form-control',
            (meta.error) && 'is-invalid',
            (meta.touched && !meta.error) && 'is-valid',
            classInput
          )}
          {...(ariaDescribedby) && {
            'aria-describedby': ariaDescribedby
          }}
        />
      </FormikInputWrapper>
    </div>
  );
}

FormikMaskedInput.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  type: PropTypes.string,
  disabled: PropTypes.bool,
  classInput: PropTypes.string,
  icon: PropTypes.string,
  swap: PropTypes.bool,
  iconProps: PropTypes.object,
  className: PropTypes.string,
  mask: PropTypes.string
};

export default FormikMaskedInput;
